module.exports = __webpack_public_path__ + "static/allyoucanmove_color-6f4bde83499984d6c676ca54184933e2.jpg";